import { useMemo } from 'react'
import { FormattedNumber } from 'react-intl'

import { Field, FieldGroup, FieldLabel, FieldSet } from '~/DesignSystem/components/field'
import { Input } from '~/DesignSystem/components/input'
import parseNumber from '~/utils/parseNumber'

import type { ProductVariant as ProductVariantType } from '../../@types'
import ProductVariantCarousel from '../ProductVariantCarousel'
import { LABELS_MAP } from './constants'

type ProductVariantProps = {
  data: ProductVariantType
}

const ProductVariant: React.FC<ProductVariantProps> = ({ data }) => {
  const { images, currency, salePrice, price } = useMemo(() => {
    return {
      images: Array.from(
        new Set([data.attributes.image_url, ...data.attributes.images].filter(Boolean)),
      ),
      currency: data.attributes.currency,
      salePrice: data.attributes.sale_price ? parseNumber(data.attributes.sale_price) : undefined,
      price: data.attributes.price ? parseNumber(data.attributes.price) : undefined,
    }
  }, [data])

  return (
    <div>
      <h1 className="text-lg font-semibold">{data.attributes.product_name} </h1>
      <p className="text-primary font-medium text-sm/6">
        {salePrice && price ? (
          <>
            <FormattedNumber style="currency" value={salePrice} currency={currency} />{' '}
            <span className="text-foreground font-normal line-through">
              <FormattedNumber style="currency" value={price} currency={currency} />
            </span>
          </>
        ) : price ? (
          <FormattedNumber style="currency" value={price} currency={currency} />
        ) : undefined}
      </p>
      <ProductVariantCarousel imageUrls={images} className="my-4 max-w-3xl" />
      <FieldSet>
        <FieldGroup className="grid grid-cols-2 gap-4">
          {data.attributes.properties.map(prop => (
            <Field key={prop.key} className="gap-1">
              <FieldLabel htmlFor={prop.key} className="font-normal">
                {LABELS_MAP[prop.key] || prop.key}
              </FieldLabel>
              <Input id={prop.key} disabled value={prop.value} />
            </Field>
          ))}
        </FieldGroup>
      </FieldSet>
    </div>
  )
}

export default ProductVariant
